/* global cdata */
import * as sentry from '@sentry/browser';
import { BrowserTracing } from "@sentry/tracing";

if (process.env.SENTRY_DSN) {
  // sentry JS Error Tracking
  sentry.init({
    release: `${process.env.SENTRY_RELEASE}`,
    dsn: `${process.env.SENTRY_DSN}`,
    environment: process.env.NODE_ENV,
    integrations: [new BrowserTracing()],
    sampleRate: 1.0,
    tracesSampleRate: 0.04,
    ignoreErrors:[
      "Non-Error exception captured",
      "Non-Error promise rejection captured"
    ]
  });

  // Set user data with cdata
  try {
    sentry.configureScope((scope) => {
      scope.setTag("framework", "vue");
      scope.setTag("initFile", "addSentry.js");

      if (typeof cdata === 'undefined') {
        sentry.captureException(new Error ('cdata not defined'));
      } else {
        scope.setUser({
          'email': cdata.email ? cdata.email : null,
          'id' : cdata.id ? cdata.id : cdata.dug
        });
      }
    });

  } catch (err) {
    sentry.captureException(err);
  }
}

export default sentry;
